/**
 * @deprecated use react-query instead
 */
export interface IdleRequestStatus<M = unknown> {
	_type: "IdleRequestStatus";
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface LoadingRequestStatus<M = unknown> {
	_type: "LoadingRequestStatus";
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface LoadingWithValueRequestStatus<T, M = unknown> {
	_type: "LoadingWithValueRequestStatus";
	value: T;
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface LoadingWithErrorRequestStatus<E, M = unknown> {
	_type: "LoadingWithErrorRequestStatus";
	error: E;
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface ErrorWithValueRequestStatus<E, T, M = unknown> {
	_type: "ErrorWithValueRequestStatus";
	error: E;
	value: T;
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface ErrorRequestStatus<E, M = unknown> {
	_type: "ErrorRequestStatus";
	error: E;
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export interface SuccessRequestStatus<T = unknown, M = unknown> {
	_type: "SuccessRequestStatus";
	value: T;
	meta?: M;
}

/**
 * @deprecated use react-query instead
 */
export type AnyErrorStatus<E, T = unknown, M = unknown> =
	| ErrorRequestStatus<E, M>
	| ErrorWithValueRequestStatus<E, T, M>
	| LoadingWithErrorRequestStatus<E, M>;

/**
 * @deprecated use react-query instead
 */
export type AnyLoadingStatus<E, T = unknown, M = unknown> =
	| LoadingRequestStatus<M>
	| LoadingWithErrorRequestStatus<E, M>
	| LoadingWithValueRequestStatus<T, M>;

/**
 * @deprecated use react-query instead
 */
export type ResponseStatus<E, T, M = unknown> = SuccessRequestStatus<T, M> | ErrorRequestStatus<E, M>;

/**
 * @deprecated use react-query instead
 */
export type AnyValueStatus<E, T = unknown, M = unknown> =
	| SuccessRequestStatus<T, M>
	| ErrorWithValueRequestStatus<E, T, M>
	| LoadingWithValueRequestStatus<T, M>;

/**
 * @deprecated use react-query instead
 */
export type RequestStatus<E, T = unknown, M = unknown> =
	| AnyErrorStatus<E, T, M>
	| AnyLoadingStatus<E, T, M>
	| AnyValueStatus<E, T, M>
	| IdleRequestStatus<M>;

/**
 * @deprecated use react-query instead
 */
export const isLoadingRequestStatus = <M = unknown>(
	value: RequestStatus<unknown, unknown, M> | undefined,
): value is LoadingRequestStatus<M> => value?._type === "LoadingRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isLoadingWithValueRequestStatus = <T = unknown, M = unknown>(
	value: RequestStatus<unknown, T, M> | undefined,
): value is LoadingWithValueRequestStatus<T, M> => value?._type === "LoadingWithValueRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isLoadingWithErrorRequestStatus = <E, M = unknown>(
	value: RequestStatus<E, unknown, M> | undefined,
): value is LoadingWithErrorRequestStatus<E, M> => value?._type === "LoadingWithErrorRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isErrorRequestStatus = <E, M = unknown>(
	value: RequestStatus<E, unknown, M> | undefined,
): value is ErrorRequestStatus<E, M> => value?._type === "ErrorRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isErrorWithValueRequestStatus = <E, T = unknown, M = unknown>(
	value: RequestStatus<E, T, M> | undefined,
): value is ErrorWithValueRequestStatus<E, T, M> => value?._type === "ErrorWithValueRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isAnyLoadingStatus = <E, T = unknown, M = unknown>(
	status: RequestStatus<E, T, M> | undefined,
): status is AnyLoadingStatus<E, T, M> =>
	isLoadingRequestStatus(status) || isLoadingWithErrorRequestStatus(status) || isLoadingWithValueRequestStatus(status);

/**
 * @deprecated use react-query instead
 */
export const isAnyErrorStatus = <E, T = unknown, M = unknown>(
	status: RequestStatus<E, T, M>,
): status is AnyErrorStatus<E, T, M> =>
	isErrorRequestStatus(status) || isLoadingWithErrorRequestStatus(status) || isErrorWithValueRequestStatus(status);

/**
 * @deprecated use react-query instead
 */
export const isAnyValueStatus = <E, T = unknown, M = unknown>(
	status: RequestStatus<E, T, M>,
): status is AnyValueStatus<E, T, M> =>
	isLoadingWithValueRequestStatus(status) || isErrorWithValueRequestStatus(status) || isSuccessRequestStatus(status);

/**
 * @deprecated use react-query instead
 */
export const isSuccessRequestStatus = <T = unknown, M = unknown>(
	value: RequestStatus<unknown, T, M> | undefined,
): value is SuccessRequestStatus<T, M> => value?._type === "SuccessRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const isIdleRequestStatus = <M = unknown>(
	value: RequestStatus<unknown, unknown, M> | undefined,
): value is IdleRequestStatus<M> | undefined => value?._type === "IdleRequestStatus";

/**
 * @deprecated use react-query instead
 */
export const getRequestStatusValue = <T = unknown>(status: RequestStatus<unknown, T> | undefined): T | undefined =>
	status != null && "value" in status ? status.value : undefined;

/**
 * @deprecated use react-query instead
 */
export const getExistingStatusValue = <T = unknown>(
	status: LoadingWithValueRequestStatus<T> | SuccessRequestStatus<T> | ErrorWithValueRequestStatus<unknown, T>,
): T => status.value;

/**
 * @deprecated use react-query instead
 */
export const getRequestStatusMeta = <M = unknown>(
	status: RequestStatus<unknown, unknown, M> | undefined,
): M | undefined => status?.meta;

/**
 * @deprecated use react-query instead
 */
export const getExistingStatusError = <E, T = unknown>(
	status: ErrorRequestStatus<E> | ErrorWithValueRequestStatus<E, T> | LoadingWithErrorRequestStatus<E>,
): E => status.error;

/**
 * @deprecated use react-query instead
 */
export const getRequestStatusError = <E, M = unknown>(
	status: RequestStatus<E, unknown, M> | undefined,
): E | undefined => (status != null && "error" in status ? status.error : undefined);

/**
 * @deprecated use react-query instead
 */
export const idleStatus = <M = unknown>(meta?: M): IdleRequestStatus<M> => {
	const status = { _type: "IdleRequestStatus" } as IdleRequestStatus<M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export const loadingStatus = <M = unknown>(meta?: M): LoadingRequestStatus<M> => {
	const status = { _type: "LoadingRequestStatus" } as LoadingRequestStatus<M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export const loadingWithValueStatus = <T = unknown, M = unknown>(
	value: T,
	meta?: M,
): LoadingWithValueRequestStatus<T, M> => {
	const status = { _type: "LoadingWithValueRequestStatus", value } as LoadingWithValueRequestStatus<T, M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export const successStatus = <T = unknown, M = unknown>(value: T, meta?: M): SuccessRequestStatus<T, M> => {
	const status = { _type: "SuccessRequestStatus", value } as SuccessRequestStatus<T, M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export const errorStatus = <E, M = unknown>(error: E, meta?: M): ErrorRequestStatus<E, M> => {
	const status = { _type: "ErrorRequestStatus", error } as ErrorRequestStatus<E, M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export const errorWithValueStatus = <E, T = unknown, M = unknown>(
	error: E,
	value: T,
	meta?: M,
): ErrorWithValueRequestStatus<E, T, M> => {
	const status = { _type: "ErrorWithValueRequestStatus", error, value } as ErrorWithValueRequestStatus<E, T, M>;
	if (meta != null) {
		status.meta = meta;
	}
	return status;
};

/**
 * @deprecated use react-query instead
 */
export type StatusErrorOf<R> = R extends AnyErrorStatus<infer E> ? E : never;
/**
 * @deprecated use react-query instead
 */
export type StatusValueOf<R> = R extends AnyValueStatus<unknown, infer T> ? T : never;
/**
 * @deprecated use react-query instead
 */
export type StatusMetaOf<R> = R extends RequestStatus<unknown, unknown, infer M> ? M : never;
/**
 * @deprecated use react-query instead
 */
export type SuccessStatusOf<R> = R extends SuccessRequestStatus ? R : never;
